import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { fetchJSON } from '../../../shared/helpers/apiCalls';
import { CREATE_NEW_PASSWORD, REQUEST_PASSWORD_RESET } from './actionType';

import { accessTokenUrl, changePasswordUrl, requestPasswordResetUrl, getActiveMode } from '../../../shared/helpers/endPoints';
import { authProcess } from '../register/action';
import { setAuthError, setAuthSuccess } from './action';
import { getStoreLocal } from '../../../shared/helpers/utils';
import { userService } from '../../../modules/users/services/dependency.injection';
import qs from 'qs';

// This is for getting general token
// let token = userService.authService.getToken('client-token');
function* callCreateNewPassword({ payload: { value, urlToken, history } }) {
    const modeType = getActiveMode();
    try {
        let token;

        const firstOptions = {
            method: 'POST',
            data: qs.stringify({ grant_type: 'client_credentials' }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            auth: userService.authService.basicToken(),
            url: accessTokenUrl(modeType)
        };
        const response = yield call(fetchJSON, firstOptions);
        userService.authService.setToken('client-token', response.data.access_token);

        token = response.data.access_token;

        const options = {
            method: 'POST',
            data: JSON.stringify({ ...value, token: urlToken }),
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            },
            url: changePasswordUrl(modeType)
        };

        yield call(fetchJSON, options);
        yield put(authProcess(false));
        yield put(setAuthSuccess('Your password reset was successful, you can now login with your new password'));
        yield put(setAuthError(""));
        // history.replace('/login');
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error?.data?.error?.message || error?.data?.message || 'Something went wrong please try again later';
        yield put(authProcess(false));
        yield put(setAuthError(message));
    }
}

function* callRequestPasswordReset({ payload: { value, history } }) {
    const modeType = getActiveMode();

    try {
        let token;

        const firstOptions = {
            method: 'POST',
            data: qs.stringify({ grant_type: 'client_credentials' }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            auth: userService.authService.basicToken(),
            url: accessTokenUrl(modeType)
        };
        const response = yield call(fetchJSON, firstOptions);
        userService.authService.setToken('client-token', response.data.access_token);

        token = response.data.access_token;

        const options = {
            method: 'POST',
            data: JSON.stringify({
                email: value.email
            }),
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            },
            url: requestPasswordResetUrl(modeType)
        };

        yield call(fetchJSON, options);

        yield put(authProcess(false));
        yield put(
            setAuthSuccess('Your Request has been successfully sent, please check your mail for further process')
        );
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(authProcess(false));
        yield put(setAuthError(message));
    }
}

// function* callLogout({ payload: history }) {
//     const response = yield userService.logout();

//     if (response.isLeft()) {
//         // toast.error('Encountered ');
//     } else {
//         yield call(() => {
//             history.replace('/');
//         });
//     }
// }

// function* callLoginUser({ payload: { value, history } }) {
//     const modeType = getStoreLocal('modeType');

//     try {
//         const options = {
//             method: 'POST',
//             data: qs.stringify({
//                 username: value.email,
//                 password: value.password,
//                 grant_type: 'password',
//                 scope: 'profile'
//             }),
//             auth: userService.authService.basicToken(),
//             url: loginUserUrl(modeType)
//         };

//         const response = yield call(fetchJSON, options);

//         // setSession(response.data);
//         authService.setToken('auth-spay-user', response.data);

//         history.replace('/dashboard');
//         yield put(authProcess(false));

//         // call the user details once the login is successful with the data gotten from the response of this request

//         // yield put(getMerchantDetails(history));
//     } catch (error) {
//         let message =
//             error === undefined
//                 ? 'Something went wrong, Kindly check your network and try again later'
//                 : error.data.error_description;

//         yield put(setAuthError(message));
//         yield put(authProcess(false));

//         // setSession(null);
//         // userService.setToken('auth-spay-user', null);
//         authService.setToken('auth-spay-user', null);
//     }
// }

export function* watchCreateNewPassword() {
    yield takeEvery(CREATE_NEW_PASSWORD, callCreateNewPassword);
}
export function* watchRequestPasswordReset() {
    yield takeEvery(REQUEST_PASSWORD_RESET, callRequestPasswordReset);
}
// export function* watchLogoutUser() {
//     yield takeEvery(LOGOUT_USER, callLogout);
// }
// export function* watchLoginUser() {
//     yield takeEvery(LOGIN_USER, callLoginUser);
// }

function* LoginSaga() {
    yield all([
        // fork(watchLoginUser),
        // fork(watchLogoutUser),
        fork(watchRequestPasswordReset),
        fork(watchCreateNewPassword)
    ]);
}

export default LoginSaga;
